import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function Comp() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();

    const linkMap: any = {
        cn: '/collections/solar-panels',
        kr: 'https://kr.ecoflow.com/pages/solar-panel',
        us: `https://${locale}.ecoflow.com/collections/delta-2-solar-generators`,
        tw: '/collections/solar-panels',
        br: 'https://br.ecoflow.com/products/delta-2-220w-portable-solar-panel',
        mx: 'https://mx.ecoflow.com/products/delta-2-220w-portable-solar-panel',
        ph: 'https://ph.ecoflow.com/products/ecoflow-delta-2-220w-solar-panel',
    };

    return (
        <div className={`${css.imgB} imgB GtmModuleData-section`} data-section-id={css.imgB} data-section-title={t('delta2.aniH_msg1')}>
            <div className="v-msg1">
                <div className="v-msg-1">{t('delta2.aniH_msg1')}</div>
                <div className="v-msg-2">
                    <span>{t('delta2.aniH_msg2')}</span>
                    <span>{t('delta2.aniH_msg2_highlight')}</span>
                </div>
            </div>
            <div className="img-item">
                <EFPic name={['imgB1.webp', 'imgB1.jpg']} />
            </div>
            <div className="v-msg2">
                <div className="v-msg-1">{t('delta2.aniH_msg5')} </div>
                {!['jp', 'cis', 'za', 'sa'].includes(locale) && (
                    <div className="v-msg-2">
                        <Link href={linkMap[locale] || linkMap.us}>
                            {t('delta2.aniH_msg6')}
                            <EFArrowDown className="v-msg-icon" />
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
